import styled from "styled-components";
import Header from "../Components/InitialPage/Header";
import Footer from "../Components/InitialPage/Footer";
import capaVip from "../Assets/fundoGrupo.png"

export default function GrupoVip() {
  const WHATSAPP_GROUP_LINK = "https://chat.whatsapp.com/DK6VgPREjXnJRRAspHtSVe?mode=wwt";

  return (
    <Container>
      <Header />

      <Hero $bg={capaVip}>
        {/* <HeroTopLine /> */}
        <HeroCenter>
          <HeroTitle>DECOLANDO COM DESCONTO</HeroTitle>
        </HeroCenter>
      </Hero>

      <White>
        <WhiteInner>
          <H2>As melhores oportunidades de viagem direto no seu WhatsApp</H2>
          <P>
            Viajar pagando menos é possível, e quem faz parte do nosso Grupo VIP
            descobre isso <b>antes de todo mundo.</b>
          </P>

          <CtaWrap>
            <CtaButton
              href={WHATSAPP_GROUP_LINK}
              target="_blank"
              rel="noreferrer"
            >
              Clique aqui e garanta já seu acesso ao <b>Grupo VIP VoeCheap</b>
            </CtaButton>

            {/* ÍCONE + ANIMAÇÃO DE CLIQUE (idêntico ao estilo do print) */}
            <ClickIcon aria-hidden="true">
              <ClickSvg viewBox="0 0 64 64">
                {/* ondas de clique */}
                <path
                  className="wave wave1"
                  d="M43 22c3-3 7-3 10 0"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
                <path
                  className="wave wave2"
                  d="M46 17c5-5 12-5 17 0"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                />

                {/* mão */}
                <path
                  className="hand"
                  d="M23 31v-7c0-2 1-3 3-3s3 1 3 3v5-10c0-2 1-3 3-3s3 1 3 3v10-8c0-2 1-3 3-3s3 1 3 3v8-5c0-2 1-3 3-3s3 1 3 3v12c0 8-5 14-13 14h-3c-8 0-11-6-11-14v-2c0-3 2-5 5-5h1z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                />

                {/* anel de clique */}
                <circle
                  className="ring"
                  cx="26"
                  cy="24"
                  r="6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                />
              </ClickSvg>
            </ClickIcon>
          </CtaWrap>

          <P2>
            Receba promoções exclusivas, alertas de passagens com valores
            imperdíveis e oportunidades usando as estratégias de milhas da
            VoeCheap.
          </P2>
        </WhiteInner>
      </White>

      <Gray>
        <GrayInner>
          <TwoCols>
            <Col>
              <ColTitle>Por que entrar no Grupo VIP?</ColTitle>
              <List>
                <li>Promoções exclusivas e por tempo limitado;</li>
                <li>Avisos em primeira mão;</li>
                <li>Oportunidades reais para viajar pagando menos;</li>
                <li>Conteúdo direto, sem spam;</li>
                <li>Atendimento facilitado quando a oferta é do seu interesse.</li>
              </List>
            </Col>

            <Col>
              <ColTitle>Para quem é o Grupo VIP?</ColTitle>
              <List>
                <li>Ama viajar e quer pagar menos;</li>
                <li>Tem flexibilidade de datas ou destinos;</li>
                <li>Não quer perder promoções relâmpago;</li>
                <li>Prefere receber tudo direto no WhatsApp.</li>
              </List>
            </Col>
          </TwoCols>

          <GrayBottom>
            Tudo pensado para quem quer economizar sem perder tempo pesquisando.
          </GrayBottom>
        </GrayInner>
      </Gray>

      <Bottom>
        <BottomInner>
          <div>As melhores passagens não esperam.</div>
          <div>Quem está no Grupo VIP VoeCheap, chega primeiro.</div>
        </BottomInner>
      </Bottom>

      <Footer />
    </Container>
  );
}

/* ===================== STYLES ===================== */

const Container = styled.div`
  width: 100%;
`;

const Hero = styled.section`
  width: 100%;
  height: 200px;
  background-image: url(${(p) => p.$bg});
  background-size: cover;
  background-position: center;
  position: relative;

  @media (max-width: 768px) {
    height: 220px;
  }
`;

// const HeroTopLine = styled.div`
//   position: absolute;
//   top: 78px; /* fica logo abaixo do Header (igual ao print) */
//   left: 0;
//   width: 100%;
//   height: 1px;
//   background: rgba(255, 255, 255, 0.65);

//   @media (max-width: 768px) {
//     top: 70px;
//   }
// `;

const HeroCenter = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeroTitle = styled.div`
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  letter-spacing: 0.8px;
  color: #fff;
  text-transform: uppercase;
  font-size: 18px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const White = styled.section`
  width: 100%;
  background: #ffffff;
`;

const WhiteInner = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 34px 20px 18px;
  text-align: center;
`;

const H2 = styled.div`
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  color: #0e0e0e;
  font-size: 18px;
  margin-bottom: 8px;
`;

const P = styled.div`
  font-family: "Montserrat", sans-serif;
  color: #0e0e0e;
  font-size: 15px;
  line-height: 1.5;
  margin: 0 auto 18px;
  max-width: 820px;

  b {
    font-weight: 800;
  }
`;

const CtaWrap = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 6px auto 18px;
`;

const CtaButton = styled.a`
  background: #5f86c2;
  color: #fff;
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-size: 14px;
  text-decoration: none;
  padding: 10px 18px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.12);
  transition: transform 0.12s ease, opacity 0.12s ease;

  b {
    font-weight: 900;
  }

  &:hover {
    transform: translateY(-1px);
    opacity: 0.96;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 10px 14px;
  }
`;

/* Ícone de clique (outline) com animação de “tap” + ring */
const ClickIcon = styled.span`
  position: absolute;
  right: -58px;
  bottom: -16px;
  color: #1a1a1a;
  width: 62px;
  height: 62px;

  @media (max-width: 768px) {
    right: -50px;
    bottom: -14px;
    transform: scale(0.92);
  }
`;

const ClickSvg = styled.svg`
  width: 100%;
  height: 100%;
  overflow: visible;

  .hand {
    transform-origin: 28px 26px;
    animation: tap 1.15s ease-in-out infinite;
  }

  .ring {
    transform-origin: 26px 24px;
    animation: ring 1.15s ease-in-out infinite;
  }

  .wave1 {
    opacity: 0.9;
    animation: wave 1.15s ease-in-out infinite;
  }

  .wave2 {
    opacity: 0.75;
    animation: wave 1.15s ease-in-out infinite;
    animation-delay: 0.08s;
  }

  @keyframes tap {
    0% {
      transform: translate(0px, 0px) scale(1);
    }
    30% {
      transform: translate(2px, 4px) scale(0.98);
    }
    45% {
      transform: translate(2px, 4px) scale(0.98);
    }
    70% {
      transform: translate(0px, 0px) scale(1);
    }
    100% {
      transform: translate(0px, 0px) scale(1);
    }
  }

  @keyframes ring {
    0% {
      opacity: 0.2;
      transform: scale(0.9);
    }
    30% {
      opacity: 0.95;
      transform: scale(1);
    }
    55% {
      opacity: 0.2;
      transform: scale(1.25);
    }
    100% {
      opacity: 0.2;
      transform: scale(0.9);
    }
  }

  @keyframes wave {
    0% {
      opacity: 0;
      transform: translate(0, 0);
    }
    20% {
      opacity: 0.9;
    }
    55% {
      opacity: 0.2;
    }
    100% {
      opacity: 0;
      transform: translate(0, 0);
    }
  }
`;

const P2 = styled.div`
  font-family: "Montserrat", sans-serif;
  color: #0e0e0e;
  font-size: 14px;
  line-height: 1.55;
  margin: 0 auto;
  max-width: 900px;
`;

const Gray = styled.section`
  width: 100%;
  background: #d9d9d9;
  margin-top: 18px;
`;

const GrayInner = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 24px 20px 18px;
`;

const TwoCols = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 34px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 18px;
  }
`;

const Col = styled.div``;

const ColTitle = styled.div`
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  color: #0e0e0e;
  font-size: 15px;
  margin-bottom: 10px;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    color: #0e0e0e;
    line-height: 1.55;
    margin-bottom: 6px;
    padding-left: 22px;
    position: relative;
  }

  li::before {
    content: "✓";
    position: absolute;
    left: 0;
    top: 0;
    font-weight: 900;
  }
`;

const GrayBottom = styled.div`
  text-align: center;
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  color: #0e0e0e;
  font-size: 14px;
  margin-top: 18px;
`;

const Bottom = styled.section`
  width: 100%;
  background: #ffffff;
`;

const BottomInner = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 22px 20px 34px;
  text-align: center;
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  color: #0e0e0e;
  font-size: 14px;
  line-height: 1.65;
`;
